<template>
  <el-dialog
    title="分类详情"
    :visible.sync="visible"
    width="750px"
    @close="$emit('update:show', false)"
    top="5vh"
  >
    <el-descriptions
      title=""
      size="small"
      :column="1"
      border
      :labelStyle="{ width: '100px' }"
    >
      <el-descriptions-item label="名称">{{
        model.whole_name
      }}</el-descriptions-item>
      <el-descriptions-item label="封面">
        <auth-img
          tag="el-image"
          style="width: 60px; height: 60px"
          :src="model.cover"
          fit="cover"
        ></auth-img>
      </el-descriptions-item>
      <el-descriptions-item label="详情">
        <div class="commodity-content" v-html="model.content"></div>
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style scoped>
.commodity-content {
  max-height: 70vh;
  overflow-y: auto;
}
/deep/.commodity-content p {
  margin-bottom: 0;
}

/deep/.commodity-content img {
  width: 100%;
}
</style>